import { render } from "./Security.vue?vue&type=template&id=29739042"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Demo/Security.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29739042"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29739042', __exports__)) {
    api.reload('29739042', __exports__)
  }
  
  module.hot.accept("./Security.vue?vue&type=template&id=29739042", () => {
    api.rerender('29739042', render)
  })

}


export default __exports__